import { useCurrentUser } from "#/components/context/user/UserContext"
import { OriginDialogContext } from "#/components/telemedicine/pelvic-floor-therapy/OriginDialogContext"
import { TtcPaths } from "#/utils/Paths"
import { Button, DialogActions, DialogContent, DialogTitle, Link, Typography } from "@carrotfertility/carotene-core"
import React, { useContext } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { useOriginStepTracking } from "#/components/telemedicine/pelvic-floor-therapy/hooks/useOriginStepTracking"

export function NoPartnerAccessStep(): JSX.Element {
  const { setOpenDialogFlow } = useContext(OriginDialogContext)
  const intl = useIntl()
  const { partnerPreferredName, partnerFirstName } = useCurrentUser()
  const { trackButtonClick } = useOriginStepTracking("No partner access")
  const partnerName = partnerPreferredName ? partnerPreferredName : partnerFirstName
  const partnerNameWithDefault = partnerName ?? intl.formatMessage({ defaultMessage: "your partner" })

  const handleClose = () => {
    trackButtonClick({ name: "Close" })
    setOpenDialogFlow(false)
  }

  return (
    <>
      <DialogTitle>
        <FormattedMessage
          defaultMessage="{partnerName} is not eligible"
          values={{ partnerName: partnerNameWithDefault }}
        />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage
            defaultMessage="We're sorry, but {partnerName} is not eligible to use Origin."
            values={{ partnerName: partnerNameWithDefault }}
          />
        </Typography>
        <Typography>
          <FormattedMessage
            defaultMessage="Questions? <link>Contact us</link>"
            values={{
              link: (linkContent) => (
                <Link color="inherit" component={RouterLink} to={TtcPaths.TTC_CARE_NAV}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </>
  )
}
